import { createRouter, createWebHistory } from 'vue-router'
import Panel from '../pages/Panel.vue'

const routes = [
  { path: "/index", component: Panel },
  { path: "/", component: Panel },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

export default router
